module.exports = __webpack_public_path__ + "320c12feae8bf2d5448fc8a76618915f.pdf";